import { __require as requireDescriptors } from './node_modules-core-js-internals-descriptors.js';
import { __require as requireObjectDefineProperty } from './node_modules-core-js-internals-object-define-property.js';
import { __require as requireCreatePropertyDescriptor } from './node_modules-core-js-internals-create-property-descriptor.js';

var createNonEnumerableProperty;
var hasRequiredCreateNonEnumerableProperty;

function requireCreateNonEnumerableProperty () {
	if (hasRequiredCreateNonEnumerableProperty) return createNonEnumerableProperty;
	hasRequiredCreateNonEnumerableProperty = 1;
	var DESCRIPTORS = requireDescriptors();
	var definePropertyModule = requireObjectDefineProperty();
	var createPropertyDescriptor = requireCreatePropertyDescriptor();

	createNonEnumerableProperty = DESCRIPTORS ? function (object, key, value) {
	  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};
	return createNonEnumerableProperty;
}

export { requireCreateNonEnumerableProperty as __require };
//# sourceMappingURL=node_modules-core-js-internals-create-non-enumerable-property.js.map
